// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"OtpLimitExceeded-module__wrapper"};